import { render, staticRenderFns } from "./SegmentsCreate.vue?vue&type=template&id=b089b8d0&"
import script from "./SegmentsCreate.vue?vue&type=script&lang=js&"
export * from "./SegmentsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports